var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKr = function SvgKr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-36 -24 72 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-36-24h72v48h-72z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kr_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kr_svg__a",
    stroke: "#000",
    strokeWidth: 2,
    d: "M-6-25H6m-12 3H6m-12 3H6"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kr_svg__a",
    y: 44
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0 17v10"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 12,
    fill: "#cd2e3a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-12A6 6 0 0 0 0 0a6 6 0 0 1 0 12 12 12 0 0 1 0-24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-123.69)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kr_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0-23.5v3M0 17v3.5m0 3v3"
  }))));
};
export default SvgKr;